import { ScriptProvider } from './script';

export {
  ScriptProvider,
}



// WEBPACK FOOTER //
// ./src/providers/script/index.ts